import styled from 'styled-components/macro';
import {NavLink} from 'react-router-dom';
import {colors, fonts, textSizes} from '@styles/vars';
import {portalMenu} from '@constants/portalMenu';
import {useSidebarContext} from '@contexts/sidebarContext';
import {useAuth} from '@hooks/useAuth';
import {List, MainItem} from './style';

const EmpresaLabel = styled.p`
  margin: -8px 0 8px;
  padding-left: 6px;
  font-family: ${fonts.body};
  font-size: ${textSizes['12']};
  line-height: 1.4;
  opacity: 0.75;
`;

const PortalContent = ({isCollapsed}) => {
    const {toggleSidebar} = useSidebarContext();
    const {user, tenantName} = useAuth();
    const activeStyle = {color: colors.blue};
    const empresaNombre =
        user?.empresa_nombre || tenantName || 'Portal de clientes';

    return (
        <>
            {!isCollapsed ? <EmpresaLabel>{empresaNombre}</EmpresaLabel> : null}
            <List>
                {portalMenu.map((item, index) => (
                    <MainItem
                        as={NavLink}
                        to={item.link}
                        onClick={() => toggleSidebar()}
                        style={({isActive}) => (isActive ? activeStyle : undefined)}
                        key={item.link}
                        className={`${index === portalMenu.length - 1 ? 'pin-down' : ''} ${isCollapsed ? 'collapsed' : ''}`}
                        data-tour-link={item.link}
                    >
                        <i className={`icon icon-${item.icon}`}></i>
                        {!isCollapsed && <span>{item.name}</span>}
                    </MainItem>
                ))}
            </List>
        </>
    );
};

export default PortalContent;
